module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "using System;\r\nusing System.Numerics;\r\nusing System.Threading;\r\nusing System.Threading.Tasks;\r\nusing Nethereum.Contracts;\r\nusing Nethereum.ABI.FunctionEncoding.Attributes;\r\nusing Nethereum.Hex.HexTypes;\r\nusing Nethereum.RPC.Eth.DTOs;\r\nusing Nethereum.Web3;\r\n\r\n// Created with 'Nethereum-CodeGenerator' https://github.com/StefH/Nethereum-CodeGenerator by stef.heyenrath@mstack.nl (mStack B.V.)\r\n// Based on abi-code-gen (https://github.com/Nethereum/abi-code-gen)\r\nnamespace <%= locals.namespace ? namespace : 'DefaultNamespace' %>\r\n{\r\n    public class <%= capitalizeFirstLetter(getContractName()) %>Service : I<%= capitalizeFirstLetter(getContractName()) %>Service\r\n    {\r\n        public static string ABI = @\"<%- abiToText(abi) %>\";\r\n\r\n        public static string ByteCode = \"0x<%-bytecode%>\";\r\n\r\n        public static async Task<string> DeployContractAsync(Web3 web3, string addressFrom, <%-generateConstructorInputParameters(abi)%> CancellationTokenSource token = null, HexBigInteger gas = null)\r\n        {\r\n            if (gas == null)\r\n            {\r\n                gas = await web3.Eth.DeployContract.EstimateGasAsync(ABI, ByteCode, addressFrom).ConfigureAwait(false);\r\n            }\r\n\r\n            var transactionReceipt = await web3.Eth.DeployContract.SendRequestAndWaitForReceiptAsync(ABI, ByteCode, addressFrom, gas, token<%-generateConstructorParameters(abi)%>).ConfigureAwait(false);\r\n            return transactionReceipt.ContractAddress;\r\n        }\r\n\r\n        private readonly Web3 _web3;\r\n        private readonly Contract _contract;\r\n\r\n        public <%= capitalizeFirstLetter(getContractName()) %>Service(Web3 web3, string address)\r\n        {\r\n            _web3 = web3;\r\n            _contract = _web3.Eth.GetContract(ABI, address);\r\n        }\r\n\r\n        public async Task<TransactionReceipt> ExecuteTransactionAsync(Func<I<%= capitalizeFirstLetter(getContractName()) %>Service, Task<string>> func, int timeoutInSeconds)\r\n        {\r\n            var cts = new CancellationTokenSource(TimeSpan.FromSeconds(timeoutInSeconds));\r\n\r\n            string transaction = await func(this);\r\n            var receipt = await _web3.Eth.Transactions.GetTransactionReceipt.SendRequestAsync(transaction).ConfigureAwait(false);\r\n\r\n            while (receipt == null && !cts.IsCancellationRequested)\r\n            {\r\n                await Task.Delay(500);\r\n                receipt = await _web3.Eth.Transactions.GetTransactionReceipt.SendRequestAsync(transaction).ConfigureAwait(false);\r\n            }\r\n\r\n            return receipt;\r\n        }\r\n\r\n        public Task<BlockWithTransactions> GetBlockWithTransactionsAsync(string blockhash)\r\n        {\r\n            return _web3.Eth.Blocks.GetBlockWithTransactionsByHash.SendRequestAsync(blockhash);\r\n        }\r\n\r\n<%= abi.forEach(generateGetFunction) %>\r\n<%= abi.forEach(generateGetEvent) %>\r\n<%= abi.forEach(generateFunctionCall) %>\r\n<%= abi.forEach(generateFunctionTransaction) %>\r\n<%= abi.forEach(generateFunctionCallMultipleOutputsDTO) %>\r\n\r\n    }\r\n\r\n<%= abi.forEach(generateFunctionOutputDTO) %>\r\n<%= abi.forEach(generateEventDTO) %>\r\n}\r\n<%_\r\nfunction getContractName() {\r\n   return locals._contractName ? locals._contractName : 'DefaultContractName';\r\n}\r\n\r\nfunction capitalizeFirstLetter(string) {\r\n    return string.charAt(0).toUpperCase() + string.slice(1);\r\n}\r\n\r\nfunction abiToText(abi) {\r\n    return JSON.stringify(abi).split('\\\"').join('\\\"\\\"');\r\n}\r\n\r\nfunction getGenericReturnType(item) {\r\n    var returnType = getReturnType(item);\r\n    return item === null ? '' : '<' + returnType + '>';\r\n}\r\n\r\nfunction generateFunctionInputParameters(item) {\r\n    var params = '';\r\n    if (item.inputs !== null && item.inputs.length > 0) {\r\n        \r\n        item.inputs.forEach( function(input, index) {\r\n            var prefix = ', ';\r\n            if (params === '') {\r\n                prefix = '';\r\n            }\r\n            params = params + prefix + getTypeMap(input.type) + ' ' + getParamName(input.name, index);\r\n        })\r\n    } \r\n    return params;\r\n}\r\n\r\nfunction getParamName(param, index) {\r\n    if (param !== '') {\r\n        return param;\r\n    }\r\n\r\n    switch (index) {\r\n        case 0:\r\n            return 'a';\r\n        case 1:\r\n            return 'b';\r\n        case 2:\r\n            return 'c';\r\n        case 3:\r\n            return 'd';\r\n        case 4:\r\n            return 'e';\r\n        case 5:\r\n            return 'f';\r\n        case 6:\r\n            return 'g';\r\n    }\r\n    return 'h';\r\n}\r\n\r\nfunction generateFunctionTransactionInputParameters(item) {\r\n    var params = generateFunctionInputParameters(item);\r\n\r\n    return params !== '' ? params + ',' : params;\r\n}\r\n\r\nfunction generateConstructorInputParameters(abi) {\r\n    var ret = '';\r\n    abi.forEach(function(item) {\r\n        if (item.type === 'constructor') {\r\n            ret = generateFunctionTransactionInputParameters(item);\r\n        }\r\n    });\r\n    return ret;\r\n}\r\n\r\nfunction generateConstructorParameters(abi) {\r\n    var ret = '';\r\n    abi.forEach( function(item) {\r\n        if (item.type === 'constructor') {\r\n            ret = generateFunctionParametersCommaPrefix(item);\r\n        }\r\n    });\r\n    return ret;\r\n}\r\n\r\nfunction generateFunctionParametersCommaPrefix(item) {\r\n    var ret = generateFunctionParameters(item);\r\n    return ret !== '' ? ', ' + ret : ret;\r\n}\r\n\r\nfunction generateFunctionParameters(item) {\r\n    var params = '';\r\n    if (item.inputs !== null && item.inputs.length > 0) {\r\n        \r\n        item.inputs.forEach( function(input, index) {\r\n            var prefix = ', ';\r\n            if (params === '') {\r\n                prefix = '';\r\n            }\r\n            params = params + prefix + getParamName(input.name, index);\r\n        })\r\n    } \r\n    return params;\r\n}\r\n\r\nfunction getReturnType(item) {\r\n    if (item.outputs !== null && item.outputs.length === 1) {\r\n        return getTypeMap(item.outputs[0].type);\r\n    }\r\n    return null;\r\n}\r\n\r\nfunction getTypeMap(typeName) {\r\n    var indexFirstBracket = typeName.indexOf('[');\r\n    if (indexFirstBracket > -1) {\r\n        var elementTypeName = typeName.substring(0, indexFirstBracket);\r\n        return getTypeMap(elementTypeName) + '[]';\r\n    }\r\n\r\n    if ('bool' === typeName) {\r\n        return typeName;\r\n    }\r\n\r\n    if (typeName.startsWith('int')) {\r\n        // default\r\n        if (typeName.length === 3) {\r\n            return 'BigInteger';\r\n        }\r\n\r\n        var length = parseInt(typeName.substring(3));\r\n        \r\n        if (length > 64) {\r\n            return 'BigInteger';\r\n        }\r\n\r\n        if (length <= 64 && length > 32) {\r\n            return 'long';\r\n        }\r\n\r\n        // ints are in 8 bits\r\n        if (length === 32 ) {\r\n            return 'int';\r\n        }\r\n\r\n        if (length === 16 ) {\r\n            return 'short';\r\n        }\r\n\r\n        if (length === 8 ) {\r\n            return 'sbyte';\r\n        }\r\n    }\r\n\r\n    if (typeName.startsWith('uint')) {\r\n       \r\n        if (typeName.length === 4) {\r\n            return 'BigInteger';\r\n        }\r\n\r\n        var length = parseInt(typeName.substring(4));\r\n        \r\n        if (length > 64) {\r\n            return 'BigInteger';\r\n        }\r\n\r\n        if (length <= 64 && length > 32) {\r\n            return 'ulong';\r\n        }\r\n        \r\n        // uints are in 8 bits steps\r\n        if (length === 32 ) {\r\n            return 'int';\r\n        }\r\n\r\n        if (length === 16 ) {\r\n            return 'short';\r\n        }\r\n\r\n        if (length === 8 ) {\r\n            return 'byte';\r\n        }\r\n    }\r\n\r\n    if (typeName === 'address') {\r\n        return 'string';\r\n    }\r\n\r\n    if (typeName === 'string') {\r\n        return 'string';\r\n    }\r\n\r\n    if (typeName === 'bytes') {\r\n        return 'byte[]';\r\n    }\r\n\r\n    // if (typeName === 'bytes32') {\r\n    //     return 'string';\r\n    // }\r\n\r\n    if (typeName.startsWith('bytes')) {\r\n        return 'byte[]';\r\n    }\r\n}\r\n\r\n_%>\r\n<%_ function generateGetFunction(item) { _%>\r\n<%_ if (item.type === 'function') { _%>\r\n        private Function GetFunction<%= capitalizeFirstLetter(item.name) %>()\r\n        {\r\n            return _contract.GetFunction(\"<%=item.name%>\");\r\n        }\r\n\r\n<%_ } }\r\n_%>\r\n<%_ function generateGetEvent(item) { _%>\r\n<%_ if (item.type === 'event') { _%>\r\n<%_ var eventName = capitalizeFirstLetter(item.name); _%>\r\n        public Event<<%=eventName%>> Get<%=eventName%>()\r\n        {\r\n            return _contract.GetEvent<<%=eventName%>>(\"<%=item.name%>\");\r\n        }\r\n\r\n<%_ } }\r\n_%>\r\n<%_ function generateFunctionCall_Original(item) { _%>\r\n<%_ if (item.type === 'function' && (item.outputs !== null && item.outputs.length === 1)) { _%>\r\n        public Task<%- getGenericReturnType(item) -%> <%= capitalizeFirstLetter(item.name) %>CallAsync(<%- generateFunctionInputParameters(item) -%>)\r\n        {\r\n            var function = GetFunction<%=capitalizeFirstLetter(item.name)%>();\r\n            return function.CallAsync<%- getGenericReturnType(item) -%>(<%- generateFunctionParameters(item) -%>);\r\n        }\r\n\r\n<%_ } }\r\n_%>\r\n<%_ function generateFunctionCall(item) { _%>\r\n<%_ if (item.type === 'function' && (item.outputs !== null && item.outputs.length === 1)) { _%>\r\n        public Task<%- getGenericReturnType(item) -%> <%= capitalizeFirstLetter(item.name) %>CallAsync(<%- generateFunctionInputParameters(item) -%>)\r\n        {\r\n            var function = GetFunction<%=capitalizeFirstLetter(item.name)%>();\r\n            return function.CallAsync<%- getGenericReturnType(item) -%>(<%- generateFunctionParameters(item) -%>);\r\n        }\r\n\r\n        public async Task<%- getGenericReturnType(item) -%> <%= capitalizeFirstLetter(item.name) %>CallAsync(string addressFrom, <%- generateFunctionTransactionInputParameters(item) -%> HexBigInteger gas = null, HexBigInteger valueAmount = null)\r\n        {\r\n            var function = GetFunction<%=capitalizeFirstLetter(item.name)%>();\r\n\r\n            if (gas == null)\r\n            {\r\n                gas = await function.EstimateGasAsync(addressFrom, gas, valueAmount<%- generateFunctionParametersCommaPrefix(item) -%>).ConfigureAwait(false);\r\n            }\r\n\r\n            return await function.CallAsync<%- getGenericReturnType(item) -%>(addressFrom, gas, valueAmount<%- generateFunctionParametersCommaPrefix(item) -%>).ConfigureAwait(false);\r\n        }\r\n\r\n<%_ } }\r\n_%>\r\n<%_ function generateFunctionCallMultipleOutputsDTO_Original(item) { _%>\r\n<%_ if (item.type === 'function' && (item.outputs !== null && item.outputs.length > 1)) { _%>\r\n        public Task<<%- capitalizeFirstLetter(item.name)  -%>> <%= capitalizeFirstLetter(item.name) %>CallAsync(<%- generateFunctionInputParameters(item) -%>)\r\n        {\r\n            var function = GetFunction<%=capitalizeFirstLetter(item.name)%>();\r\n            return function.CallDeserializingToObjectAsync<<%- capitalizeFirstLetter(item.name) -%>>(<%- generateFunctionParameters(item) -%>);\r\n        }\r\n\r\n<%_ } }\r\n_%>\r\n<%_ function generateFunctionCallMultipleOutputsDTO(item) { _%>\r\n<%_ if (item.type === 'function' && (item.outputs !== null && item.outputs.length > 1)) { _%>\r\n        public Task<<%- capitalizeFirstLetter(item.name)  -%>> <%= capitalizeFirstLetter(item.name) %>CallAsync(<%- generateFunctionInputParameters(item) -%>)\r\n        {\r\n            var function = GetFunction<%=capitalizeFirstLetter(item.name)%>();\r\n            return function.CallDeserializingToObjectAsync<<%- capitalizeFirstLetter(item.name) -%>>(<%- generateFunctionParameters(item) -%>);\r\n        }\r\n\r\n        public async Task<<%- capitalizeFirstLetter(item.name)  -%>> <%= capitalizeFirstLetter(item.name) %>CallAsync(string addressFrom, <%- generateFunctionTransactionInputParameters(item) -%>  HexBigInteger gas = null, HexBigInteger valueAmount = null)\r\n        {\r\n            var function = GetFunction<%=capitalizeFirstLetter(item.name)%>();\r\n\r\n            if (gas == null)\r\n            {\r\n                gas = await function.EstimateGasAsync(addressFrom, gas, valueAmount<%- generateFunctionParametersCommaPrefix(item) -%>).ConfigureAwait(false);\r\n            }\r\n\r\n            return await function.CallDeserializingToObjectAsync<<%- capitalizeFirstLetter(item.name) -%>>(addressFrom, gas, valueAmount<%- generateFunctionParametersCommaPrefix(item) -%>).ConfigureAwait(false);\r\n        }\r\n\r\n<%_ } }\r\n_%>\r\n<%_ function generateFunctionTransaction(item) { _%>\r\n<%_ if (item.type === 'function' && item.constant === false) { _%>\r\n        public async Task<string> <%= capitalizeFirstLetter(item.name) %>Async(string addressFrom, <%- generateFunctionTransactionInputParameters(item) -%> HexBigInteger gas = null, HexBigInteger valueAmount = null)\r\n        {\r\n            var function = GetFunction<%=capitalizeFirstLetter(item.name)%>();\r\n\r\n            if (gas == null)\r\n            {\r\n                gas = await function.EstimateGasAsync(addressFrom, gas, valueAmount<%- generateFunctionParametersCommaPrefix(item) -%>).ConfigureAwait(false);\r\n            }\r\n\r\n            return await function.SendTransactionAsync(addressFrom, gas, valueAmount<%- generateFunctionParametersCommaPrefix(item) -%>).ConfigureAwait(false);\r\n        }\r\n\r\n<%_ } }\r\n_%>\r\n<%_ function generateFunctionOutputDTOProperty(param, index) { _%>\r\n        [Parameter(\"<%=param.type%>\", \"<%=param.name%>\", <%=index + 1%>)]\r\n        public <%-getTypeMap(param.type)-%> <%-capitalizeFirstLetter(getParamName(param.name, index))-%> { get; set; }\r\n\r\n<%_ }\r\n_%>\r\n<%_ function generateEventDTOProperty(param, index) { _%>\r\n        [Parameter(\"<%=param.type%>\", \"<%=param.name%>\", <%=index + 1%>, <%= param.indexed ? 'true' : 'false'%>)]\r\n        public <%-getTypeMap(param.type)-%> <%-capitalizeFirstLetter(getParamName(param.name, index))-%> { get; set; }\r\n\r\n<%_ }\r\n_%>\r\n<%_ function generateFunctionOutputDTO(item) { _%>\r\n<%_ if (item.type === 'function' && item.outputs !== null && item.outputs.length > 1 ) { _%>\r\n    [FunctionOutput]\r\n    public class <%=capitalizeFirstLetter(item.name)%>\r\n    {\r\n<%- item.outputs.forEach(generateFunctionOutputDTOProperty) -%>\r\n    }\r\n\r\n<%_ } }\r\n_%>\r\n<%_ function generateEventDTO(item) { _%>\r\n<%_ if (item.type === 'event' && item.inputs !== null && item.inputs.length > 1 ) { _%>\r\n<%_ var eventName = capitalizeFirstLetter(item.name); _%>\r\n    [Event(\"<%=eventName%>\")]\r\n    public class <%=eventName%> : IEventDTO\r\n    {\r\n<%- item.inputs.forEach(generateEventDTOProperty) -%>\r\n    }\r\n\r\n<%_ } }\r\n_%>"
  , __filename = "src\\business\\cs-service.ejs";
try {
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("using System;\r\nusing System.Numerics;\r\nusing System.Threading;\r\nusing System.Threading.Tasks;\r\nusing Nethereum.Contracts;\r\nusing Nethereum.ABI.FunctionEncoding.Attributes;\r\nusing Nethereum.Hex.HexTypes;\r\nusing Nethereum.RPC.Eth.DTOs;\r\nusing Nethereum.Web3;\r\n\r\n// Created with 'Nethereum-CodeGenerator' https://github.com/StefH/Nethereum-CodeGenerator by stef.heyenrath@mstack.nl (mStack B.V.)\r\n// Based on abi-code-gen (https://github.com/Nethereum/abi-code-gen)\r\nnamespace ")
    ; __line = 13
    ; __append(escapeFn( locals.namespace ? namespace : 'DefaultNamespace' ))
    ; __append("\r\n{\r\n    public class ")
    ; __line = 15
    ; __append(escapeFn( capitalizeFirstLetter(getContractName()) ))
    ; __append("Service : I")
    ; __append(escapeFn( capitalizeFirstLetter(getContractName()) ))
    ; __append("Service\r\n    {\r\n        public static string ABI = @\"")
    ; __line = 17
    ; __append( abiToText(abi) )
    ; __append("\";\r\n\r\n        public static string ByteCode = \"0x")
    ; __line = 19
    ; __append(bytecode)
    ; __append("\";\r\n\r\n        public static async Task<string> DeployContractAsync(Web3 web3, string addressFrom, ")
    ; __line = 21
    ; __append(generateConstructorInputParameters(abi))
    ; __append(" CancellationTokenSource token = null, HexBigInteger gas = null)\r\n        {\r\n            if (gas == null)\r\n            {\r\n                gas = await web3.Eth.DeployContract.EstimateGasAsync(ABI, ByteCode, addressFrom).ConfigureAwait(false);\r\n            }\r\n\r\n            var transactionReceipt = await web3.Eth.DeployContract.SendRequestAndWaitForReceiptAsync(ABI, ByteCode, addressFrom, gas, token")
    ; __line = 28
    ; __append(generateConstructorParameters(abi))
    ; __append(").ConfigureAwait(false);\r\n            return transactionReceipt.ContractAddress;\r\n        }\r\n\r\n        private readonly Web3 _web3;\r\n        private readonly Contract _contract;\r\n\r\n        public ")
    ; __line = 35
    ; __append(escapeFn( capitalizeFirstLetter(getContractName()) ))
    ; __append("Service(Web3 web3, string address)\r\n        {\r\n            _web3 = web3;\r\n            _contract = _web3.Eth.GetContract(ABI, address);\r\n        }\r\n\r\n        public async Task<TransactionReceipt> ExecuteTransactionAsync(Func<I")
    ; __line = 41
    ; __append(escapeFn( capitalizeFirstLetter(getContractName()) ))
    ; __append("Service, Task<string>> func, int timeoutInSeconds)\r\n        {\r\n            var cts = new CancellationTokenSource(TimeSpan.FromSeconds(timeoutInSeconds));\r\n\r\n            string transaction = await func(this);\r\n            var receipt = await _web3.Eth.Transactions.GetTransactionReceipt.SendRequestAsync(transaction).ConfigureAwait(false);\r\n\r\n            while (receipt == null && !cts.IsCancellationRequested)\r\n            {\r\n                await Task.Delay(500);\r\n                receipt = await _web3.Eth.Transactions.GetTransactionReceipt.SendRequestAsync(transaction).ConfigureAwait(false);\r\n            }\r\n\r\n            return receipt;\r\n        }\r\n\r\n        public Task<BlockWithTransactions> GetBlockWithTransactionsAsync(string blockhash)\r\n        {\r\n            return _web3.Eth.Blocks.GetBlockWithTransactionsByHash.SendRequestAsync(blockhash);\r\n        }\r\n\r\n")
    ; __line = 62
    ; __append(escapeFn( abi.forEach(generateGetFunction) ))
    ; __append("\r\n")
    ; __line = 63
    ; __append(escapeFn( abi.forEach(generateGetEvent) ))
    ; __append("\r\n")
    ; __line = 64
    ; __append(escapeFn( abi.forEach(generateFunctionCall) ))
    ; __append("\r\n")
    ; __line = 65
    ; __append(escapeFn( abi.forEach(generateFunctionTransaction) ))
    ; __append("\r\n")
    ; __line = 66
    ; __append(escapeFn( abi.forEach(generateFunctionCallMultipleOutputsDTO) ))
    ; __append("\r\n\r\n    }\r\n\r\n")
    ; __line = 70
    ; __append(escapeFn( abi.forEach(generateFunctionOutputDTO) ))
    ; __append("\r\n")
    ; __line = 71
    ; __append(escapeFn( abi.forEach(generateEventDTO) ))
    ; __append("\r\n}\r\n")
    ; __line = 73
    ; 
function getContractName() {
   return locals._contractName ? locals._contractName : 'DefaultContractName';
}

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function abiToText(abi) {
    return JSON.stringify(abi).split('\"').join('\"\"');
}

function getGenericReturnType(item) {
    var returnType = getReturnType(item);
    return item === null ? '' : '<' + returnType + '>';
}

function generateFunctionInputParameters(item) {
    var params = '';
    if (item.inputs !== null && item.inputs.length > 0) {
        
        item.inputs.forEach( function(input, index) {
            var prefix = ', ';
            if (params === '') {
                prefix = '';
            }
            params = params + prefix + getTypeMap(input.type) + ' ' + getParamName(input.name, index);
        })
    } 
    return params;
}

function getParamName(param, index) {
    if (param !== '') {
        return param;
    }

    switch (index) {
        case 0:
            return 'a';
        case 1:
            return 'b';
        case 2:
            return 'c';
        case 3:
            return 'd';
        case 4:
            return 'e';
        case 5:
            return 'f';
        case 6:
            return 'g';
    }
    return 'h';
}

function generateFunctionTransactionInputParameters(item) {
    var params = generateFunctionInputParameters(item);

    return params !== '' ? params + ',' : params;
}

function generateConstructorInputParameters(abi) {
    var ret = '';
    abi.forEach(function(item) {
        if (item.type === 'constructor') {
            ret = generateFunctionTransactionInputParameters(item);
        }
    });
    return ret;
}

function generateConstructorParameters(abi) {
    var ret = '';
    abi.forEach( function(item) {
        if (item.type === 'constructor') {
            ret = generateFunctionParametersCommaPrefix(item);
        }
    });
    return ret;
}

function generateFunctionParametersCommaPrefix(item) {
    var ret = generateFunctionParameters(item);
    return ret !== '' ? ', ' + ret : ret;
}

function generateFunctionParameters(item) {
    var params = '';
    if (item.inputs !== null && item.inputs.length > 0) {
        
        item.inputs.forEach( function(input, index) {
            var prefix = ', ';
            if (params === '') {
                prefix = '';
            }
            params = params + prefix + getParamName(input.name, index);
        })
    } 
    return params;
}

function getReturnType(item) {
    if (item.outputs !== null && item.outputs.length === 1) {
        return getTypeMap(item.outputs[0].type);
    }
    return null;
}

function getTypeMap(typeName) {
    var indexFirstBracket = typeName.indexOf('[');
    if (indexFirstBracket > -1) {
        var elementTypeName = typeName.substring(0, indexFirstBracket);
        return getTypeMap(elementTypeName) + '[]';
    }

    if ('bool' === typeName) {
        return typeName;
    }

    if (typeName.startsWith('int')) {
        // default
        if (typeName.length === 3) {
            return 'BigInteger';
        }

        var length = parseInt(typeName.substring(3));
        
        if (length > 64) {
            return 'BigInteger';
        }

        if (length <= 64 && length > 32) {
            return 'long';
        }

        // ints are in 8 bits
        if (length === 32 ) {
            return 'int';
        }

        if (length === 16 ) {
            return 'short';
        }

        if (length === 8 ) {
            return 'sbyte';
        }
    }

    if (typeName.startsWith('uint')) {
       
        if (typeName.length === 4) {
            return 'BigInteger';
        }

        var length = parseInt(typeName.substring(4));
        
        if (length > 64) {
            return 'BigInteger';
        }

        if (length <= 64 && length > 32) {
            return 'ulong';
        }
        
        // uints are in 8 bits steps
        if (length === 32 ) {
            return 'int';
        }

        if (length === 16 ) {
            return 'short';
        }

        if (length === 8 ) {
            return 'byte';
        }
    }

    if (typeName === 'address') {
        return 'string';
    }

    if (typeName === 'string') {
        return 'string';
    }

    if (typeName === 'bytes') {
        return 'byte[]';
    }

    // if (typeName === 'bytes32') {
    //     return 'string';
    // }

    if (typeName.startsWith('bytes')) {
        return 'byte[]';
    }
}


    ; __line = 275
    ; __line = 276
    ;  function generateGetFunction(item) { 
    ; __line = 277
    ;  if (item.type === 'function') { 
    ; __append("        private Function GetFunction")
    ; __line = 278
    ; __append(escapeFn( capitalizeFirstLetter(item.name) ))
    ; __append("()\r\n        {\r\n            return _contract.GetFunction(\"")
    ; __line = 280
    ; __append(escapeFn(item.name))
    ; __append("\");\r\n        }\r\n\r\n")
    ; __line = 283
    ;  } }

    ; __line = 284
    ; __line = 285
    ;  function generateGetEvent(item) { 
    ; __line = 286
    ;  if (item.type === 'event') { 
    ; __line = 287
    ;  var eventName = capitalizeFirstLetter(item.name); 
    ; __append("        public Event<")
    ; __line = 288
    ; __append(escapeFn(eventName))
    ; __append("> Get")
    ; __append(escapeFn(eventName))
    ; __append("()\r\n        {\r\n            return _contract.GetEvent<")
    ; __line = 290
    ; __append(escapeFn(eventName))
    ; __append(">(\"")
    ; __append(escapeFn(item.name))
    ; __append("\");\r\n        }\r\n\r\n")
    ; __line = 293
    ;  } }

    ; __line = 294
    ; __line = 295
    ;  function generateFunctionCall_Original(item) { 
    ; __line = 296
    ;  if (item.type === 'function' && (item.outputs !== null && item.outputs.length === 1)) { 
    ; __append("        public Task")
    ; __line = 297
    ; __append( getGenericReturnType(item) )
    ; __append(" ")
    ; __append(escapeFn( capitalizeFirstLetter(item.name) ))
    ; __append("CallAsync(")
    ; __append( generateFunctionInputParameters(item) )
    ; __append(")\r\n        {\r\n            var function = GetFunction")
    ; __line = 299
    ; __append(escapeFn(capitalizeFirstLetter(item.name)))
    ; __append("();\r\n            return function.CallAsync")
    ; __line = 300
    ; __append( getGenericReturnType(item) )
    ; __append("(")
    ; __append( generateFunctionParameters(item) )
    ; __append(");\r\n        }\r\n\r\n")
    ; __line = 303
    ;  } }

    ; __line = 304
    ; __line = 305
    ;  function generateFunctionCall(item) { 
    ; __line = 306
    ;  if (item.type === 'function' && (item.outputs !== null && item.outputs.length === 1)) { 
    ; __append("        public Task")
    ; __line = 307
    ; __append( getGenericReturnType(item) )
    ; __append(" ")
    ; __append(escapeFn( capitalizeFirstLetter(item.name) ))
    ; __append("CallAsync(")
    ; __append( generateFunctionInputParameters(item) )
    ; __append(")\r\n        {\r\n            var function = GetFunction")
    ; __line = 309
    ; __append(escapeFn(capitalizeFirstLetter(item.name)))
    ; __append("();\r\n            return function.CallAsync")
    ; __line = 310
    ; __append( getGenericReturnType(item) )
    ; __append("(")
    ; __append( generateFunctionParameters(item) )
    ; __append(");\r\n        }\r\n\r\n        public async Task")
    ; __line = 313
    ; __append( getGenericReturnType(item) )
    ; __append(" ")
    ; __append(escapeFn( capitalizeFirstLetter(item.name) ))
    ; __append("CallAsync(string addressFrom, ")
    ; __append( generateFunctionTransactionInputParameters(item) )
    ; __append(" HexBigInteger gas = null, HexBigInteger valueAmount = null)\r\n        {\r\n            var function = GetFunction")
    ; __line = 315
    ; __append(escapeFn(capitalizeFirstLetter(item.name)))
    ; __append("();\r\n\r\n            if (gas == null)\r\n            {\r\n                gas = await function.EstimateGasAsync(addressFrom, gas, valueAmount")
    ; __line = 319
    ; __append( generateFunctionParametersCommaPrefix(item) )
    ; __append(").ConfigureAwait(false);\r\n            }\r\n\r\n            return await function.CallAsync")
    ; __line = 322
    ; __append( getGenericReturnType(item) )
    ; __append("(addressFrom, gas, valueAmount")
    ; __append( generateFunctionParametersCommaPrefix(item) )
    ; __append(").ConfigureAwait(false);\r\n        }\r\n\r\n")
    ; __line = 325
    ;  } }

    ; __line = 326
    ; __line = 327
    ;  function generateFunctionCallMultipleOutputsDTO_Original(item) { 
    ; __line = 328
    ;  if (item.type === 'function' && (item.outputs !== null && item.outputs.length > 1)) { 
    ; __append("        public Task<")
    ; __line = 329
    ; __append( capitalizeFirstLetter(item.name)  )
    ; __append("> ")
    ; __append(escapeFn( capitalizeFirstLetter(item.name) ))
    ; __append("CallAsync(")
    ; __append( generateFunctionInputParameters(item) )
    ; __append(")\r\n        {\r\n            var function = GetFunction")
    ; __line = 331
    ; __append(escapeFn(capitalizeFirstLetter(item.name)))
    ; __append("();\r\n            return function.CallDeserializingToObjectAsync<")
    ; __line = 332
    ; __append( capitalizeFirstLetter(item.name) )
    ; __append(">(")
    ; __append( generateFunctionParameters(item) )
    ; __append(");\r\n        }\r\n\r\n")
    ; __line = 335
    ;  } }

    ; __line = 336
    ; __line = 337
    ;  function generateFunctionCallMultipleOutputsDTO(item) { 
    ; __line = 338
    ;  if (item.type === 'function' && (item.outputs !== null && item.outputs.length > 1)) { 
    ; __append("        public Task<")
    ; __line = 339
    ; __append( capitalizeFirstLetter(item.name)  )
    ; __append("> ")
    ; __append(escapeFn( capitalizeFirstLetter(item.name) ))
    ; __append("CallAsync(")
    ; __append( generateFunctionInputParameters(item) )
    ; __append(")\r\n        {\r\n            var function = GetFunction")
    ; __line = 341
    ; __append(escapeFn(capitalizeFirstLetter(item.name)))
    ; __append("();\r\n            return function.CallDeserializingToObjectAsync<")
    ; __line = 342
    ; __append( capitalizeFirstLetter(item.name) )
    ; __append(">(")
    ; __append( generateFunctionParameters(item) )
    ; __append(");\r\n        }\r\n\r\n        public async Task<")
    ; __line = 345
    ; __append( capitalizeFirstLetter(item.name)  )
    ; __append("> ")
    ; __append(escapeFn( capitalizeFirstLetter(item.name) ))
    ; __append("CallAsync(string addressFrom, ")
    ; __append( generateFunctionTransactionInputParameters(item) )
    ; __append("  HexBigInteger gas = null, HexBigInteger valueAmount = null)\r\n        {\r\n            var function = GetFunction")
    ; __line = 347
    ; __append(escapeFn(capitalizeFirstLetter(item.name)))
    ; __append("();\r\n\r\n            if (gas == null)\r\n            {\r\n                gas = await function.EstimateGasAsync(addressFrom, gas, valueAmount")
    ; __line = 351
    ; __append( generateFunctionParametersCommaPrefix(item) )
    ; __append(").ConfigureAwait(false);\r\n            }\r\n\r\n            return await function.CallDeserializingToObjectAsync<")
    ; __line = 354
    ; __append( capitalizeFirstLetter(item.name) )
    ; __append(">(addressFrom, gas, valueAmount")
    ; __append( generateFunctionParametersCommaPrefix(item) )
    ; __append(").ConfigureAwait(false);\r\n        }\r\n\r\n")
    ; __line = 357
    ;  } }

    ; __line = 358
    ; __line = 359
    ;  function generateFunctionTransaction(item) { 
    ; __line = 360
    ;  if (item.type === 'function' && item.constant === false) { 
    ; __append("        public async Task<string> ")
    ; __line = 361
    ; __append(escapeFn( capitalizeFirstLetter(item.name) ))
    ; __append("Async(string addressFrom, ")
    ; __append( generateFunctionTransactionInputParameters(item) )
    ; __append(" HexBigInteger gas = null, HexBigInteger valueAmount = null)\r\n        {\r\n            var function = GetFunction")
    ; __line = 363
    ; __append(escapeFn(capitalizeFirstLetter(item.name)))
    ; __append("();\r\n\r\n            if (gas == null)\r\n            {\r\n                gas = await function.EstimateGasAsync(addressFrom, gas, valueAmount")
    ; __line = 367
    ; __append( generateFunctionParametersCommaPrefix(item) )
    ; __append(").ConfigureAwait(false);\r\n            }\r\n\r\n            return await function.SendTransactionAsync(addressFrom, gas, valueAmount")
    ; __line = 370
    ; __append( generateFunctionParametersCommaPrefix(item) )
    ; __append(").ConfigureAwait(false);\r\n        }\r\n\r\n")
    ; __line = 373
    ;  } }

    ; __line = 374
    ; __line = 375
    ;  function generateFunctionOutputDTOProperty(param, index) { 
    ; __append("        [Parameter(\"")
    ; __line = 376
    ; __append(escapeFn(param.type))
    ; __append("\", \"")
    ; __append(escapeFn(param.name))
    ; __append("\", ")
    ; __append(escapeFn(index + 1))
    ; __append(")]\r\n        public ")
    ; __line = 377
    ; __append(getTypeMap(param.type))
    ; __append(" ")
    ; __append(capitalizeFirstLetter(getParamName(param.name, index)))
    ; __append(" { get; set; }\r\n\r\n")
    ; __line = 379
    ;  }

    ; __line = 380
    ; __line = 381
    ;  function generateEventDTOProperty(param, index) { 
    ; __append("        [Parameter(\"")
    ; __line = 382
    ; __append(escapeFn(param.type))
    ; __append("\", \"")
    ; __append(escapeFn(param.name))
    ; __append("\", ")
    ; __append(escapeFn(index + 1))
    ; __append(", ")
    ; __append(escapeFn( param.indexed ? 'true' : 'false'))
    ; __append(")]\r\n        public ")
    ; __line = 383
    ; __append(getTypeMap(param.type))
    ; __append(" ")
    ; __append(capitalizeFirstLetter(getParamName(param.name, index)))
    ; __append(" { get; set; }\r\n\r\n")
    ; __line = 385
    ;  }

    ; __line = 386
    ; __line = 387
    ;  function generateFunctionOutputDTO(item) { 
    ; __line = 388
    ;  if (item.type === 'function' && item.outputs !== null && item.outputs.length > 1 ) { 
    ; __append("    [FunctionOutput]\r\n    public class ")
    ; __line = 390
    ; __append(escapeFn(capitalizeFirstLetter(item.name)))
    ; __append("\r\n    {\r\n")
    ; __line = 392
    ; __append( item.outputs.forEach(generateFunctionOutputDTOProperty) )
    ; __append("    }\r\n\r\n")
    ; __line = 395
    ;  } }

    ; __line = 396
    ; __line = 397
    ;  function generateEventDTO(item) { 
    ; __line = 398
    ;  if (item.type === 'event' && item.inputs !== null && item.inputs.length > 1 ) { 
    ; __line = 399
    ;  var eventName = capitalizeFirstLetter(item.name); 
    ; __append("    [Event(\"")
    ; __line = 400
    ; __append(escapeFn(eventName))
    ; __append("\")]\r\n    public class ")
    ; __line = 401
    ; __append(escapeFn(eventName))
    ; __append(" : IEventDTO\r\n    {\r\n")
    ; __line = 403
    ; __append( item.inputs.forEach(generateEventDTOProperty) )
    ; __append("    }\r\n\r\n")
    ; __line = 406
    ;  } }

    ; __line = 407
  }
  return __output.join("");
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

}